<template>
  <div class="pr" style="height: 100%;">

	<!-- <div class="wh40 dcc br5 pa_br f12 b_bai" style="right: 5px;" @click="backs()">返回</div>
	<div class="pa_br wp100" style="right: 5px;bottom:100px;white-space: pre-line;" id="log"></div> -->

    <router-view></router-view>
  </div>
</template>
  
<script>
	export default {
		name: 'App',

		data() {
			return {
				uniReady:false
			}
		},

		created() {
			var that = this;
			// 同步缓存数据
			that.saveState()
		},

		// 销毁之前
		beforeUnmount() {
		},

		mounted() {
			// 监听 UniAppJSBridgeReady 事件
			// document.addEventListener('UniAppJSBridgeReady', () => {
			// 	alert('UniAppJSBridgeReady 已触发，可以调用 uni API');
			// 	this.uniReady = true;
			// });
		},

		methods: {

			checkUniReady() {
				if (!this.uniReady) {
					alert('UniApp JSBridge 未就绪，请稍后再试');
					return false;
				}
				return true;
			},

			backs(){

				// 先检查 uni API 是否就绪（在 web-view 中可能不需要）
				// if (!this.checkUniReady()) return;

				alert('点击触发 backs()'); // iPhone 5 也能看到
				this.debug('点击触发 backs()');

				try {
					// 在 web-view 中，通过 postMessage 向小程序发送消息
					// 尝试 window.postMessage 和 window.parent.postMessage
					const message = {
						action: 'navigateTo',
						url: '/pages/index/index'
					};
					window.postMessage(message, '*');
					window.parent.postMessage(message, '*');
					this.debug('postMessage 发送成功');
					console.log('发送消息:', message); // 添加 console.log 调试
				} catch (e) {
					// 捕获同步错误
					this.debug('发送 postMessage 出错: ' + e.message);
					console.error('postMessage 错误:', e);
				}
			},

			debug(msg) {
				// 或者写到页面
				const logEl = document.getElementById('log');
				if(logEl) logEl.innerText += msg + '\n';
			},

			// 同步缓存数据
			saveState() {
				// 在页面加载时读取sessionStorage
				if (sessionStorage.getItem('store')) {
					this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
				}

				// 在页面刷新时将store保存到sessionStorage里
				window.addEventListener('beforeunload', () => {
					sessionStorage.setItem('store', JSON.stringify(this.$store.state))
				})

				this.$store.state.isMobile = this.isMobileFun();
			},

			isMobileFun() {
				// 这里使用了一个简单的正则表达式来判断userAgent中是否包含常见的移动设备字符串  
				// 注意：这个正则表达式可能需要根据实际情况进行调整  
				const ua = navigator.userAgent.toLowerCase();  
				const isAndroid = /android/.test(ua);  
				const isiOS = /iphone|ipad|ipod/.test(ua);  
				// 也可以添加对Windows Phone、BlackBerry等其他移动操作系统的检测  
				// 但这里为了示例简洁，只检测Android和iOS  
				return isAndroid || isiOS;  
			}
		},
	}

	// ResizeObserver loop completed with undelivered notifications.
	// 解决ResizeObserver循环完成但未送达通知的问题
	const debounce = (fn, delay) => {
		let timer = null;
		return function () {
			let context = this;
			let args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function () {
			fn.apply(context, args);
			}, delay);
		}
	}

	const _ResizeObserver = window.ResizeObserver;
		window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
		constructor(callback) {
			callback = debounce(callback, 16);
			super(callback);
		}
	}
</script>


<style lang="less">
  // 全局css
	@import '@/style/global.less';

	#app {
		height: 100vh;
		background: #f1f1f1;
	}

	.el-row{
		width: 100%;
	}

	.el-table__inner-wrapper{
		height: 100% !important;
	}

	.el-table__body-wrapper{

		.butList{
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;

			.el-button+.el-button{
				margin-left: 0px !important;
				margin-top: 5px;
				margin-bottom: 5px;
			}
		}
	}

	// 滚动条样式
	.mytable-scrollbar {
		::-webkit-scrollbar {
			// width: 8px;
			height: 8px;
		}
		::-webkit-scrollbar-thumb {
			border-radius: 4px;
		}
	}

</style>

